<template>
  <div class="release-goods main-bg">
    <div class="main-wrap">
      <div class="mt20">
        <business-menu></business-menu>
        <div class="fr release-r">
          <span class="icon-notice">i</span><nav-crumb class="crumb-pt"></nav-crumb>
          <el-form :hide-required-asterisk="true" :model="businessForm" :rules="businessRules" ref="businessForm" label-width="110px" class="business-form">
            <div class="base-info part">
              <p class="title-name">基础信息</p>
              <div class="part-top">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="商品标题" prop="goodsName">
                      <el-input v-model="businessForm.goodsName" placeholder="请输入标题（5-30个字）" minlength="5" maxlength="30"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="分类" prop="leiBieTypeName">
                      <el-cascader
                              v-model="businessForm.leiBieTypeName"
                              class="inp-txt"
                              :options="typeAllList"
                              :props="levelDefault"
                              placeholder="请选择"
                              @change="getTypeId"
                      ></el-cascader>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="专业类" prop="leiBie">
                      <el-select class="inp-txt"  v-model="businessForm.leiBie" placeholder="请选择">
                        <el-option
                                v-for="item in leiBieList"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="带花" prop="daiHua">
                      <el-select class="inp-txt" v-model="businessForm.daiHua" placeholder="请选择">
                        <el-option
                                v-for="item in daiHua"
                                :key="item"
                                :label="item"
                                :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="规格">
                      <el-col :span="12">
                        <el-form-item prop="penNum">
                          <el-input type="number" :maxlength="2" v-model="businessForm.penNum" placeholder="请输入盆数" @input="onchangeMiao"></el-input>盆
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item prop="miaoNum">
                          <el-input type="number" :maxlength="2" v-model="businessForm.miaoNum" placeholder="请输入苗数" @input="onchangeMiao"></el-input>苗
                        </el-form-item>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="base-info part mt10">
              <p class="title-name">拍卖信息</p>
              <div class="part-top">
                <el-row :gutter="20" v-show="isShowPrice">
                  <el-col :span="12">
                    <el-form-item label="起拍价" prop="startPrice">
                      <el-input type="number" class="inp-txt" :maxlength="6" v-model="businessForm.startPrice" placeholder="请输入起拍价"></el-input> 元
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="加价幅度" prop="addPrice">
                      <el-input type="number" class="inp-txt" :maxlength="6" v-model="businessForm.addPrice" placeholder="请输入加价幅度"></el-input> 元
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="一口价" prop="onePrice">
                      <el-input type="number" class="inp-txt" :maxlength="6" v-model="businessForm.onePrice" placeholder="请输入一口价" @input="changeOnePrice"></el-input> 元
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <div class="goods-radio">
                      <el-radio v-model="isSetPrice" :label="1">不需要</el-radio>
                      <el-radio v-model="isSetPrice" :label="2">仅一口价</el-radio>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="邮费">
                      <el-input type="number" class="inp-txt" :maxlength="6" v-model="businessForm.distributionFee" placeholder="请输入邮费" @input="changeFee"></el-input> 元
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <div class="goods-radio">
                      <el-radio v-model="isSetPostage" :label="1">包邮</el-radio>
                      <el-radio v-model="isSetPostage" :label="2">邮费到付</el-radio>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="截止时间">
                      <el-select v-model="timeIndex" placeholder="请选择" @change="handleCommand">
                        <el-option
                                v-for="(item,index) in timeList"
                                :key="index"
                                :label="item+'天'"
                                :value="item">
                        </el-option>
                      </el-select>
                      <span>{{businessForm.overTime}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="base-info part mt10">
              <p class="title-name">商品属性</p>
              <div class="part-top">
                <el-row :gutter="20" v-show="isShowPrice">
                  <el-col :span="12">
                    <el-form-item label="兰花小类">
                      <el-input class="inp-txt" v-model="businessForm.orchidSubcategory" placeholder="请输入兰花小类"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="最长叶">
                      <el-input class="inp-txt" v-model="businessForm.longestLeaf" placeholder="请输入最长叶"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="最宽叶">
                      <el-input class="inp-txt" v-model="businessForm.widestLeaf" placeholder="请输入最宽叶"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="总叶数">
                      <el-input type="number" class="inp-txt" :maxlength="6" v-model="businessForm.totalLeaves" placeholder="请输入总叶数"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="母苗状况">
                      <el-input class="inp-txt" v-model="businessForm.motherSeedlingStatus" placeholder="请输入母苗状况"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="新苗状况">
                      <el-input class="inp-txt" v-model="businessForm.newSeedlingStatus" placeholder="请输入新苗状况"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="三代苗状况">
                      <el-input class="inp-txt" v-model="businessForm.threeGenerationSeedlingStatus" placeholder="请输入三代苗状况"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="四代苗状况">
                      <el-input class="inp-txt" v-model="businessForm.fourGenerationSeedlingStatus" placeholder="请输入四代苗状况"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="新芽状况">
                      <el-input class="inp-txt" v-model="businessForm.sproutStatus" placeholder="请输入新芽状况"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="花苞状况">
                      <el-input class="inp-txt" v-model="businessForm.budStatus" placeholder="请输入花苞状况"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="焦尾状况">
                      <el-input class="inp-txt" v-model="businessForm.cokeTailCondition" placeholder="请输入焦尾状况"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="黑点状况">
                      <el-input class="inp-txt" v-model="businessForm.blackSpotCondition" placeholder="请输入黑点状况"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="病菌状况">
                      <el-input class="inp-txt" v-model="businessForm.germStatus" placeholder="请输入病菌状况"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="photo-info part mt10">
              <p class="title-name">图文描述</p>
              <div class="part-top">
                <el-form-item label="商品描述" prop="goodsDesc">
                  <el-input
                          type="textarea"
                          placeholder="请描述拍品的细节"
                          v-model="businessForm.goodsDesc"
                          :autosize="{ minRows: 7, maxRows: 25}"
                          resize="none"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item label="上传商品封面" prop="goodsLog">
                  <upload-file flag="上传商品封面" v-model="businessForm.goodsLog" :limit="1" />
                </el-form-item>
                <el-form-item label="上传商品轮播图" prop="goodsImg">
                  <upload-file flag="上传商品轮播图" v-model="businessForm.goodsImg" :limit="9" />
                </el-form-item>
                <el-form-item>
                  <button type="button" class="btn-apply" @click="submitAddGoods('businessForm')">确认发布</button>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
    import BusinessMenu from '../../components/setting/businessMenu'
    import navCrumb from '../../components/crumb/index'
    import Rules from '../../utils/rules'
    import uploadFile from '../../components/uploadFile/index'
    import {getIndexTypeAll,addGoods,delGoodsForShop,upDownGoods,findGoodsInfoById} from '../../api/goods'
  export default {
      data(){
          return {
              shopInfo:JSON.parse(localStorage.getItem('shop'))||null,
              userInfo:JSON.parse(localStorage.getItem('user'))||null,
              timeIndex:1,
              businessForm:{
                  goodsName:'',//商品名称
                  goodsLog:'',
                  goodsImg:'',//商品轮播图
                  goodsInfoImg:'',//商品详情图
                  goodsVideo:'',//商品视频
                  sizeName:'',//规格
                  penNum:'',//规格
                  miaoNum:'',//规格
                  overTime:'2020-07-30 20:30:00',//规格
                  price:0,//
                  addPrice:0,//加价幅度
                  onePrice:0,//一口价
                  startPrice:0,//起拍价
                  stock:0,//库存
                  distributionFee:0,//邮费
                  goodsDesc:'',//商品描述
                  oneTypeId:'',
                  twoTypeId:'',
                  goodsType:3,
                  daiHua:'',
                  leiBie:'',
                  leiBieTypeName:'',
                  /*兰花小类*/
                  orchidSubcategory:"",
                /* 最长叶*/
                longestLeaf:"",
                /* 最宽叶*/
                widestLeaf:"",
                /* 总叶数*/
                totalLeaves:"",

                /*母苗状况*/
                motherSeedlingStatus:"",

                /*新苗状况*/
                newSeedlingStatus:"",

                /*三代苗状况*/
                threeGenerationSeedlingStatus:"",

                /*四代苗状况*/
                fourGenerationSeedlingStatus:"",

                /*新芽状况*/
                sproutStatus:"",
                /*    花苞状况*/

                budStatus:"",
                /*焦尾状况*/
                cokeTailCondition:"",

                /*黑点状况*/
                blackSpotCondition:"",

                /*病菌状况*/
                germStatus:""
              },
              businessRules:{
                  goodsName: Rules.required('请输入商品名称'),
                  goodsLog: Rules.required('请选择商品图片'),
                  goodsImg: Rules.required('请选择商品轮播图'),
//                  sizeName: Rules.required('请输入规格'),
                  penNum: Rules.required('请输入盆数'),
                  miaoNum: Rules.required('请输入苗数'),
                  startPrice: Rules.required('请输入起拍价'),
                  addPrice: Rules.required('请输入加价幅度'),
                  stock: Rules.required('请输入库存'),
                  goodsDesc: Rules.required('请输入商品描述'),
                  leiBie: Rules.required('请选择专业类'),
                  leiBieTypeName: Rules.required('请选择分类')
              },
              levelDefault:{
                  value:'id',
                  label:'typeName',
                  children:'twoTypes'
              },
              daiHua:['不带花','带花苞','已开花'],
              leiBieList:['传统品种','下山品种','组培品种','杂交品种'],
              typeAllList:[],
              isSetPostage:1,//是否设置邮费
              isSetPrice:1,//是否设置一口价
              isShowPrice:true,//是否显示起拍价
          }
      },
      components:{
          BusinessMenu,
          navCrumb,
          uploadFile
      },
      computed:{
          goodsId(){
              return this.$route.params.goodsId||'';
          },
          timeList(){
              let list=[];
              for(var i=1;i<31;i++){
                  list.push(i)
              }
              return list;
          }
      },
      created () {
          this.getTypeAll();
      },
      mounted(){
          if(this.goodsId!==''){
              this.getGoodsInfoById();
          }
      },
      methods:{
          changeFee(){
              if(this.businessForm.distributionFee>0){
                  this.isSetPostage=0
              }else{
                  this.isSetPostage=1

              }
          },
          changeOnePrice(){
              if(this.isSetPrice==1&&this.businessForm.onePrice>0){
                  this.isSetPrice=0
              }
          },
          formatDate(date) {
              var y = date.getFullYear();
              var m = date.getMonth() + 1;
              m = m < 10 ? '0' + m : m;
              var d = date.getDate();
              d = d < 10 ? ('0' + d) : d;
              return y + '-' + m + '-' + d;
          },
    handleCommand(){
              let currentTime = new Date().getTime()+this.timeIndex*24*60*60*1000;
              this.businessForm.overTime=this.formatDate(new Date(currentTime))+' 20:30:00';
              console.log('this.businessForm.overTime',this.businessForm.overTime)
          },
          onchangeMiao(e){
            this.$forceUpdate();
          },
          getTypeId(val){
              if(val.length===2){
                  this.businessForm.oneTypeId=val[0];
                  this.businessForm.twoTypeId=val[1];
              }

          },
          getTypeAll(){
              getIndexTypeAll({
                  type:2
              }).then(res=>{
                  this.typeAllList=res.data;
              })
          },
          getGoodsInfoById(){
              findGoodsInfoById({
                  goodsId:this.goodsId,
                  current:1,
                  size:1
              }).then(res=>{
                  this.businessForm=res.data.goods;
                  this.businessForm.leiBieTypeName=[res.data.oneType.id,res.data.twoType.id];
                  let currentTime = new Date().getTime()+24*60*60*1000;
                  this.businessForm.overTime=this.formatDate(new Date(currentTime))+' 20:30:00';
                  let sizeName = res.data.goods.sizeName;
                  if(sizeName&&sizeName.indexOf('盆')>=0&&sizeName.indexOf('苗')>=0){
                      this.businessForm.penNum = res.data.goods.sizeName.substring(0,sizeName.indexOf('盆'));
                      this.businessForm.miaoNum=res.data.goods.sizeName.substring(sizeName.indexOf('盆')+1,sizeName.indexOf('苗'));
                  }else{
                      this.businessForm.penNum=1;
                      this.businessForm.miaoNum=0
                  }
                  if(this.businessForm.distributionFee==-1){
                      this.businessForm.distributionFee=0
                      this.isSetPostage=2
                  }else if(this.businessForm.distributionFee==0){
                      this.businessForm.distributionFee=0
                      this.isSetPostage=1
                  }else if(this.businessForm.distributionFee>0){
                      this.isSetPostage=0
                  }
              })
          },
          submitAddGoods(formName){
              this.$refs[formName].validate((valid) => {
                  if (valid) {
                      let params = JSON.parse(JSON.stringify(this.businessForm));
                      params.sizeName=params.penNum+'盆'+params.miaoNum+"苗";
                      delete params.id;
                      delete params.state;

                      if(this.isSetPostage==2){
                          params.distributionFee=-1;
                      }
                      if(this.isSetPrice==2){
                          params.startPrice=params.onePrice;
                          params.addPrice=0;
                      }
                      params.price=params.startPrice;
                      addGoods(params).then(async (res)=>{
                          if(this.goodsId!==''){
                              await delGoodsForShop(this.goodsId).then(()=>{ })
                          }
                          this.$confirm('是否确认上架？', '提示', {
                              confirmButtonText: '确定',
                              cancelButtonText: '取消',
                              type: 'warning'
                          }).then(() => {
                              upDownGoods({
                                  goodsId:res.data.id,
                                  status:1
                              }).then(info=>{
                                  this.$message({
                                      type: 'success',
                                      message: '上架成功!'
                                  });
                              })
                              let that = this;
                              setTimeout(function () {
                                  that.$router.back();
                              },1000)

                          }).catch(() => {
                              this.$router.back();
                          });

                      })

                  } else {
                      console.log('error submit!!');
                      return false;
                  }
              });
          }
      },
      watch:{
          'isSetPostage'(val){
              if(val==1||val==2){
                  this.businessForm.distributionFee=0
              }
          },
          'isSetPrice'(val){
              if(val==1){
                  this.businessForm.onePrice=0;
                  this.isShowPrice=true;
              }
              if(val==2){
                  this.isShowPrice=false;

              }
          },
          'leiBieTypeName'(val){
              this.businessForm.oneTypeId=val[0];
              this.businessForm.twoTypeId=val[1];
          }


      }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/common';
  .crumb-pt{padding:0 0 20px;display: inline-block;line-height:20px;}
  .release-r{
    width:1000px;
    .icon-notice{
      vertical-align: top;
      margin-right:10px;
      display: inline-block;
      text-align: center;
      line-height:20px;
      color:#fff;
      width:20px;
      height:20px;
      background-color:$main-color;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
    }
    .goods-radio{
      width:300px;
      height:40px;
      padding-left:40px;
      line-height:40px;
    }
  }
  .part{
    background-color:#fff;

    .title-name{font-size:14px;color:#222;
      height:54px;
      line-height:54px;
      padding-left:30px;
      font-weight:600;border-bottom:1px dashed #EEEEEE;}
  }
  .part-top{
    padding:20px 80px;
  }
.business-form{
  .inp-txt{width:300px;height:38px;background-color:#FCFCFC;
    display: inline-block;}
}
  .store-map{
    width:626px;
    height:288px;
    background-color:$main-color;
  }
  .upload-certificates{
    display: inline-block;
    &+.upload-certificates{margin-left:50px;}
    border:1px dashed #E4E5E5;
    width:150px;
    height:150px;
    text-align: center;
    color:#999999;
    .upload-plus{padding-top:30px;}
    .btn-plus{font-size:60px;color:#c9c9c9;}

  }
  .btn-apply{
    width:170px;
    height:36px;
    background:$main-color;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    font-size:14px;
    color:#fff;
    margin-top:26px;
  }
</style>
<style lang="scss">
  @import '../../assets/css/common';
  .business-form{
    .el-form-item{
      white-space:nowrap;}
    .el-input__inner{background-color:#FCFCFC;border:1px solid #E4E5E5;}
  }
  .el-radio{margin-right:40px;}
  .el-radio__inner:hover{border:1px solid $main-color;}
  .el-radio__input.is-checked .el-radio__inner{
    border-color: $main-color;
    background: $main-color;}
  .el-radio__input.is-checked+.el-radio__label{color:#333333;}
  .el-textarea__inner{border:1px solid #E4E5E5;background-color:#FCFCFC;
    -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
    border-radius: 0px;}
</style>
